import React, { Component } from "react"
import PageForm from './components/page-form'
import { pagesService } from '../../services/tibesa.api'
import Swal from 'sweetalert2'

export default class PageAdd extends Component {
    constructor(props) {
        super(props);
    }

    submitChanges(formData) {
        Swal.fire({
            title: '¿Seguro que deseas guardar la Pagina?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sí',
            cancelButtonText: 'Cancelar',
            showLoaderOnConfirm: true,
            preConfirm: () => {
                return pagesService.create(formData)
                    .then(response => {
                        return response;
                    })
                    .catch(error => {
                        Swal.showValidationMessage(
                            `Error en la petición: ${error}`
                        )
                    });
            },
            allowOutsideClick: () => !Swal.isLoading()
        })
            .then((response) => {
                console.log(response);
                if (response.value && response.value.data && response.value.data.status === 200) {
                    Swal.fire(
                        '¡Perfecto!',
                        '¡Nuevo Pagina creada!',
                        'success'
                    ).then(() => {
                        if (response.value.data.results) {
                            window.location.href = `/pages/${response.value.data.results}`;
                        }
                        else {
                            window.location.href = '/pages';
                        }
                    });
                } else if(!response.dismiss == 'cancel') {
                    Swal.fire(
                        'Algo salio mal :C',
                        'Hubo un error al realizar la petición',
                        'error'
                      );
                }
            });
    }

    render() {
        return (
            <>
                <div className="air__utils__heading">
                    <a href="/pages">Listado de Paginas</a><span>{" "}/{" "}Agregar Pagina</span>
                </div>
                <PageForm onSubmit={this.submitChanges}></PageForm>
            </>
        )
    }
}
